  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmUnsupportedBrowserNotice
   * @description
   *   Informatory notice for unsupported browsers. ng-if used to display element based on user agent. This is duplicated on the page for IE9 and below.
   * @example
   *   Usage:
   *        <rm-unsupported-browser-notice ng-if="isUnsupported()"></rm-unsupported-browser-notice>
   */
  
rmOBA.directive('rmUnsupportedBrowserNotice', function(
    ) {
    return {
        restrict: 'E',
        templateUrl: 'directives/rmUnsupportedBrowserNotice/rmUnsupportedBrowserNotice.html',
        link: function (scope) {
        }
    }
});